var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 26.6673C23.6394 26.6673 24.8333 25.4734 24.8333 24.0007C24.8333 22.5279 23.6394 21.334 22.1667 21.334C20.6939 21.334 19.5 22.5279 19.5 24.0007C19.5 25.4734 20.6939 26.6673 22.1667 26.6673Z",
    stroke: "#757575",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83464 26.6673C10.3074 26.6673 11.5013 25.4734 11.5013 24.0007C11.5013 22.5279 10.3074 21.334 8.83464 21.334C7.36188 21.334 6.16797 22.5279 6.16797 24.0007C6.16797 25.4734 7.36188 26.6673 8.83464 26.6673Z",
    stroke: "#757575",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16797 23.9639C4.70568 23.8911 3.79344 23.6734 3.14428 23.0244C2.49512 22.3752 2.2776 21.4629 2.2047 20.0007M11.5013 24.0006H19.5013M24.8346 23.9639C26.2969 23.8911 27.2092 23.6734 27.8584 23.0244C28.8346 22.048 28.8346 20.4767 28.8346 17.334V14.6673H22.568C21.5753 14.6673 21.0789 14.6673 20.6773 14.5368C19.8654 14.273 19.2289 13.6365 18.9652 12.8247C18.8346 12.423 18.8346 11.9267 18.8346 10.934C18.8346 9.44496 18.8346 8.70045 18.6389 8.09792C18.2432 6.88017 17.2885 5.92542 16.0708 5.52976C15.4682 5.33398 14.7237 5.33398 13.2346 5.33398H2.16797",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 10.666H10.168",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16797 14.666H7.5013",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.832 8H21.2603C23.2008 8 24.171 8 24.9606 8.47161C25.7502 8.94323 26.2102 9.79748 27.1302 11.506L28.832 14.6667",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDelivery);
export default __webpack_public_path__ + "static/media/truck-delivery.bcf322fdc461ad9662e33573cd5deaa3.svg";
export { ForwardRef as ReactComponent };